import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/open-api';
import { UserControllerService } from './../../open-api/api/userController.service';

@Component({
  selector: 'app-login2famodal',
  templateUrl: './login2famodal.component.html',
  styleUrls: ['./login2famodal.component.css']
})
export class Login2famodalComponent  implements OnInit {

  newForm: FormGroup;
  @Input() email: string;
  @Input() pwd: string;
  user = new EventEmitter<User>();

  title = 'otp-app';

  otp!: string;
  inputDigitLeft: string = "Verify code";
  btnStatus: string = "btn-light";

  public configOptions = {
    length: 6,
    inputClass: 'digit-otp',
    containerClass: 'd-flex justify-content-between'
  }

  constructor(public activeModal: NgbActiveModal,
    private userControllerService: UserControllerService) { }

  ngOnInit(): void {
    this.newForm = new FormGroup({
      'otpcode': new FormControl(null, Validators.required)
    });
  }
  
  onSubmit() {
    
    this.userControllerService.loginwith2FA(this.email, this.pwd, this.newForm.value.otpcode).subscribe(
      (res) => {
        this.user.emit(res);
      }
    );
    this.activeModal.close();
  }

  onOtpChange(event: any) {
    this.otp = event;
    if(this.otp.length == this.configOptions.length) {
      this.userControllerService.loginwith2FA(this.email, this.pwd, this.otp).subscribe(
        (res) => {
          this.user.emit(res);
        }
      );
      this.activeModal.close();
      }
  }

}
